import React, { Component } from 'react';
import firebase from '../helper/firebase';
import Head from '../components/Head';

import JobCardHeader from '../components/JobCardHeader';
import JobCardContent from '../components/JobCardContent';
import JobCardMedia from '../components/JobCardMedia';
import IDNotFound from '../components/IDNotFound';
import UnpublishedJob from '../components/UnpublishedJob';
import Snack from '../components/Snack';
import AddressLinkBar from '../components/AddressLinkBar';
import AboutCompany from '../components/AboutCompany';
import CompanyStatsCard from '../components/CompanyStatsCard';
import OfferSubscribeCard from '../components/OfferSubscribeCard';
import LoggedOutCard from '../components/LoggedOutCard';
import PrivateJob from '../components/PrivateJob';
import SectionTitle from '../components/SectionTitle';
import ShareSuggestionCard from '../components/ShareSuggestionCard';
import SkeletonCard from '../components/SkeletonCard';
import SkeletonSectionTitle from '../components/SkeletonSectionTitle';
import Fav from '../components/Fav';
import JobCardMapExpander from '../components/JobCardMapExpander';
import ApplyCard from '../components/ApplyCard';
import RichCard from '../components/RichCard';
import JobContainer from '../components/JobContainer';

import { GetToken, ReactGoogleAnalytics } from '../helper/functions';
import { Title } from '../helper/consts';

import { CircularProgress, Card, Divider, Hidden } from 'material-ui';
import Fade from 'material-ui/transitions/Fade';

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	}
};

export default class Offer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: true,
			authLoading: true,
			offerLoading: true,
			jobLoading: true,
			favoriteLoading: true,
			shareLoading: true,
			share: false,
			oid: '',
			snackStatus: false,
			snackMessage: ''
		};
	}

	componentDidMount() {
		let oid = this.props.match.params.oid;
		this.getOffer(oid);
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				const { uid, email, displayName, photoURL } = user;
				this.setState({
					uid: user.uid,
					user: { uid, email, displayName, photoURL },
					authLoading: false,
					loggedIn: true
				});
				if (
					!this.state.jobLoading &&
					!this.state.offerLoading &&
					this.state.job
				) {
					GetToken()
						.then(token => {
							if (this.state.job.status === 'published') {
								this.getOID(this.state.job.jid, token);
							}
						})
						.catch(error => {
							this.setState({
								snackStatus: true,
								snackMessage: `Error: Plese try again.`
							});
						});
				}
			} else {
				if (!!this.state.uid && !!this.state.offer && Object.keys(this.state.offer).length !== 0) {
					firebase
						.database()
						.ref(`favorites/${this.state.uid}/${this.state.oid}`)
						.off();
				}
				this.setState({
					uid: '',
					user: null,
					oid: '',
					rating: null,
					favorite: false,
					recipientEmail: '',
					recipientAbout: '',
					authLoading: false,
					loggedIn: false,
					favoriteLoading: false,
					shareLoading: true,
					share: false,
					snackStatus: false,
					snackMessage: ''
				});
			}
		});
	}

	componentWillUnmount() {
		const { uid, offer } = this.state;
		const ref = firebase.database().ref();
		if (!!offer && Object.keys(offer).length !== 0) {
			ref.child(`favorites/${uid}/${offer.oid}`).off();
		}
	}

	getOffer = oid => {
		firebase
			.firestore()
			.collection('offers')
			.doc(oid)
			.get()
			.then(offerSnap => {
				if (offerSnap.data() !== null) {
					ReactGoogleAnalytics('Offers', 'View', oid, null, null);
					this.setState({
						offer: offerSnap.data(),
						offerLoading: false
					});
					this.getJob(offerSnap.data().jid, false);
				} else {
					this.getJob(oid, true);
				}
			})
			.catch(offerErr => {
				this.setState({
					snackStatus: true,
					snackMessage: `Error: ${offerErr}`
				});
			});
	};

	getJob = (jid, getOffer) => {
		const { uid } = this.state;
		const ref = firebase.database().ref();
		firebase
			.firestore()
			.collection('jobs')
			.doc(jid)
			.get()
			.then(jobSnap => {
				if (!!jobSnap.data()) {
					ReactGoogleAnalytics('Jobs', 'View', jobSnap.data().jid, null, null);
					this.setState({
						job: jobSnap.data(),
						jobLoading: false
					});
					if (getOffer && this.state.loggedIn && this.state.uid) {
						ref
							.child(`myOffers/${uid}/${jobSnap.data().jid}`)
							.once('value')
							.then(myOfferSnap => {
								if (myOfferSnap.val() !== null) {
									this.getOffer(myOfferSnap.val().oid);
								} else {
									this.setState({
										offer: {},
										offerLoading: false
									});
								}
							})
							.catch(myOfferErr => {
								this.setState({
									snackStatus: true,
									snackMessage: `Error: ${myOfferErr}`
								});
							});
					}
					if (getOffer && !this.state.authLoading && !this.state.loggedIn) {
						this.setState({
							offer: {},
							offerLoading: false
						});
					}
					if (!this.state.authLoading && this.state.loggedIn) {
						GetToken()
							.then(token => {
								if (jobSnap.data().status === 'published') {
									this.getOID(jobSnap.data().jid, token);
								}
							})
							.catch(error => {
								this.setState({
									snackStatus: true,
									snackMessage: `Error: Plese try again.`
								});
							});
					}
				} else {
					this.setState({
						snackStatus: true,
						snackMessage: `Error: Offer not found.`
					});
				}
			})
			.catch(jobErr => {
				this.setState({
					snackStatus: true,
					snackMessage: `Error: ${jobErr}`
				});
			});
	};

	getOID = (jid, token) => {
		const options = {
			method: 'post',
			headers: {
				Authorization: 'Bearer ' + token
			}
		};
		const { uid } = this.state;
		const oid = this.props.match.params.oid;
		const url = `https://us-central1-talent-7d36f.cloudfunctions.net/getPermissionIfPrivateJob?oid=${oid}&jid=${jid}&uid=${uid}`;
		fetch(url, options)
			.then(data => {
				if (data.status === 200) {
					return data.json();
				} else {
					this.setState({
						oid: '',
						shareLoading: false,
						share: false,
						snackStatus: true,
						snackMessage: 'Private Posting.'
					});
					return Promise.reject('Private Posting');
				}
			})
			.then(res => {
				if (res.data && res.data.oid) {
					this.setState({
						oid: res.data.oid,
						shareLoading: false,
						share: true
					});
				} else {
					this.getNewOID();
				}
			})
			.catch(err => {
				this.setState({
					oid: '',
					shareLoading: false,
					share: false,
					snackStatus: true,
					snackMessage: `Error: ${err}`
				});
			});
	};

	getNewOID = () => {
		let { offer, uid, job } = this.state;
		const ref = firebase.database().ref();
		const newOID = ref.push().key;
		let promises = [];
		if (offer.users) {
			offer.users.push(uid);
		} else {
			let users = offer.users || [];
			users.push(uid);
			offer['users'] = users;
		}
		let newOffer = offer;
		newOffer.oid = newOID;
		const offersPromise = firebase
			.firestore()
			.collection('offers')
			.doc(newOID)
			.set(newOffer, { merge: true });
		promises.push(offersPromise);
		offer.users.forEach(uid => {
			const userCountPromise = ref
				.child(`myOffers/${uid}/${job.jid}/shareCount`)
				.transaction(shareCount => {
					return (shareCount || 0) + 1;
				});
			promises.push(userCountPromise);
		});
		const myOffersObject = {
			oid: newOID,
			jid: job.jid,
			timestamp: Date.now(),
			shareCount: null
		};
		const myOffersPromise = ref
			.child(`myOffers/${uid}/${job.jid}`)
			.update(myOffersObject);
		promises.push(myOffersPromise);
		Promise.all(promises)
			.then(() => {
				this.setState({
					oid: newOID,
					shareLoading: false,
					share: true
				});
			})
			.catch(err => {
				this.setState({
					oid: '',
					shareLoading: false,
					share: false,
					snackStatus: true,
					snackMessage: 'Error #3. Please try again later.'
				});
			});
	};

	renderJob = () => {
		const { job, offer, uid } = this.state;
		let html = [];
		if (Object.keys(job).length === 0) {
			let card = <IDNotFound key="no ID" user={this.state.user} />;
			html.push(card);
			return html;
		} else {
			let card = (
				<Fade key={job.jid} in={true}>
					<Card className="card">
						{job.image && <JobCardMedia job={job} />}
						<JobCardHeader
							loading={this.state.jobLoading || this.state.offerLoading}
							job={job}
							status={true}
						/>
						{this.state.loggedIn && <Fav job={job} oid={offer.oid} uid={uid} />}
						<Divider light />
						<JobCardContent wrap={false} job={job} />
						<JobCardMapExpander location={job.location} />
						<AddressLinkBar location={job.location} />
					</Card>
				</Fade>
			);
			html.push(card);
			return html;
		}
	};

	closeSnack = () => {
		this.setState({ snackStatus: false, snackMessage: '' });
	};

	render() {
		return (
			<React.Fragment>
				<Head title={`Job | ${Title}`} />
				<div
					className="body"
					id={this.state.loggedIn ? 'loggedInBody' : 'loggedOutBody'}
				>
					{this.state.authLoading && (
						<CircularProgress style={style.loading} size={75} />
					)}
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'center',
							width: '100%'
						}}
					>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center'
							}}
							className="cardColumn"
						>
							{!this.state.authLoading &&
								!this.state.loggedIn && (
									<Hidden lgUp>
										<AboutCompany />
									</Hidden>
								)}

							{!this.state.authLoading &&
								(this.state.jobLoading || this.state.offerLoading) && (
									<SkeletonSectionTitle />
								)}
							{!this.state.authLoading &&
								!this.state.jobLoading &&
								!this.state.offerLoading && (
									<SectionTitle
										key="jobCard_title"
										title={`${this.state.job.title} @ ${
											this.state.job.company
										}`}
									/>
								)}
							{!this.state.authLoading && (
								<JobContainer
									mapExpander={true}
									addressBar={true}
									header={true}
									media={true}
									content={true}
									loading={this.state.jobLoading || this.state.offerLoading}
									job={this.state.job}
									status={true}
									wrap={false}
									uid={this.state.uid}
									oid={this.state.oid}
									fav={true}
								/>
							)}
							{!this.state.authLoading &&
								!this.state.jobLoading &&
								!this.state.offerLoading &&
								!!this.state.job && <RichCard job={this.state.job} />}
							{!this.state.jobLoading &&
								!this.state.offerLoading &&
								this.state.job &&
								this.state.job.status !== 'published' && (
									<UnpublishedJob status={this.state.job.status} />
								)}

							{(this.state.jobLoading ||
								!this.state.job ||
								this.state.offerLoading ||
								this.state.shareLoading ||
								!this.state.oid ||
								!this.state.share) &&
								this.state.loggedIn && (
									<Hidden lgUp>
										<SkeletonSectionTitle />
									</Hidden>
								)}
							{(this.state.jobLoading ||
								!this.state.job ||
								this.state.offerLoading ||
								this.state.shareLoading ||
								!this.state.oid ||
								!this.state.share) &&
								this.state.loggedIn && (
									<Hidden lgUp>
										<SkeletonCard header={true} content={true} actions={true} />
									</Hidden>
								)}
							{!this.state.jobLoading &&
								!this.state.offerLoading &&
								this.state.job &&
								this.state.job.status === 'published' &&
								this.state.loggedIn &&
								!this.state.shareLoading &&
								!!this.state.oid &&
								!!this.state.share && (
									<Hidden lgUp>
										<SectionTitle key="applyCard_title" title="Apply" />
									</Hidden>
								)}
							{!this.state.jobLoading &&
								!this.state.offerLoading &&
								this.state.job &&
								this.state.job.status === 'published' &&
								this.state.loggedIn &&
								!this.state.shareLoading &&
								!!this.state.oid &&
								!!this.state.share && (
									<Hidden lgUp>
										<ApplyCard
											oid={this.state.oid}
											job={this.state.job}
											user={this.state.user}
										/>
									</Hidden>
								)}

							{!this.state.jobLoading &&
								!this.state.offerLoading &&
								this.state.job &&
								this.state.job.status === 'published' &&
								this.state.loggedIn &&
								this.state.shareLoading && (
									<Hidden lgUp>
										<SkeletonSectionTitle />
									</Hidden>
								)}
							{!this.state.jobLoading &&
								!this.state.offerLoading &&
								this.state.job &&
								this.state.job.status === 'published' &&
								this.state.loggedIn &&
								this.state.shareLoading && (
									<Hidden lgUp>
										<SkeletonCard header={true} content={true} actions={true} />
									</Hidden>
								)}
							{!this.state.jobLoading &&
								!this.state.offerLoading &&
								this.state.job &&
								this.state.job.status === 'published' &&
								this.state.loggedIn &&
								!this.state.shareLoading &&
								!!this.state.oid &&
								!!this.state.share && (
									<Hidden lgUp>
										<SectionTitle key="applyCard_share" title="Share" />
									</Hidden>
								)}
							{!this.state.jobLoading &&
								!this.state.offerLoading &&
								this.state.job &&
								this.state.job.status === 'published' &&
								this.state.loggedIn &&
								!this.state.shareLoading &&
								!!this.state.oid &&
								!!this.state.share && (
									<Hidden lgUp>
										<ShareSuggestionCard
											oid={this.state.oid}
											uid={this.state.uid}
											jid={this.state.job.jid}
										/>
									</Hidden>
								)}

							{!this.state.jobLoading &&
								this.state.job &&
								this.state.job.status === 'published' &&
								this.state.loggedIn &&
								!this.state.shareLoading &&
								!!!this.state.share && (
									<Hidden lgUp>
										<PrivateJob />
									</Hidden>
								)}

							{!this.state.authLoading &&
								!this.state.loggedIn && (
									<Hidden lgUp>
										<LoggedOutCard />
									</Hidden>
								)}
						</div>
						<Hidden mdDown>
							{!this.state.jobLoading &&
								this.state.job.status !== 'hired' && (
									<div className="rightCardColumn">
										{!this.state.authLoading &&
											!this.state.loggedIn && (
												<Hidden mdDown>
													<AboutCompany />
												</Hidden>
											)}

										{(this.state.jobLoading ||
											!this.state.job ||
											this.state.offerLoading ||
											this.state.shareLoading) &&
											this.state.loggedIn && <SkeletonSectionTitle />}
										{(this.state.jobLoading ||
											!this.state.job ||
											this.state.offerLoading ||
											this.state.shareLoading) &&
											this.state.loggedIn && (
												<SkeletonCard
													header={true}
													content={true}
													actions={true}
												/>
											)}

										{!this.state.jobLoading &&
											!this.state.offerLoading &&
											this.state.job &&
											this.state.job.status === 'published' &&
											this.state.loggedIn &&
											!this.state.shareLoading &&
											!!this.state.oid &&
											!!this.state.share && (
												<SectionTitle key="applyCard_title" title="Apply" />
											)}
										{!this.state.jobLoading &&
											!this.state.offerLoading &&
											this.state.job &&
											this.state.job.status === 'published' &&
											this.state.loggedIn &&
											!this.state.shareLoading &&
											!!this.state.oid &&
											!!this.state.share && (
												<ApplyCard
													oid={this.state.oid}
													job={this.state.job}
													user={this.state.user}
												/>
											)}

										{!this.state.jobLoading &&
											!this.state.offerLoading &&
											this.state.job &&
											this.state.job.status === 'published' &&
											this.state.loggedIn &&
											this.state.shareLoading && <SkeletonSectionTitle />}
										{!this.state.jobLoading &&
											!this.state.offerLoading &&
											this.state.job &&
											this.state.job.status === 'published' &&
											this.state.loggedIn &&
											this.state.shareLoading && (
												<SkeletonCard
													header={true}
													content={true}
													actions={true}
												/>
											)}
										{!this.state.jobLoading &&
											!this.state.offerLoading &&
											this.state.job &&
											this.state.job.status === 'published' &&
											this.state.loggedIn &&
											!this.state.shareLoading &&
											!!this.state.oid &&
											!!this.state.share && (
												<SectionTitle key="applyCard_share" title="Share" />
											)}
										{!this.state.jobLoading &&
											!this.state.offerLoading &&
											this.state.job &&
											this.state.job.status === 'published' &&
											this.state.loggedIn &&
											!this.state.shareLoading &&
											!!this.state.oid &&
											!!this.state.share && (
												<ShareSuggestionCard
													oid={this.state.oid}
													uid={this.state.uid}
													jid={this.state.job.jid}
												/>
											)}

										{!this.state.jobLoading &&
											this.state.job &&
											this.state.job.status === 'published' &&
											this.state.loggedIn &&
											!this.state.shareLoading &&
											!!!this.state.share && (
												<SectionTitle
													key="private_posting_title"
													title="Private Posting"
												/>
											)}
										{!this.state.jobLoading &&
											this.state.job &&
											this.state.job.status === 'published' &&
											this.state.loggedIn &&
											!this.state.shareLoading &&
											!!!this.state.share && <PrivateJob />}

										{!this.state.jobLoading &&
											this.state.job &&
											!this.state.job.privateCompanyStats &&
											!!this.state.job.glassdoorId &&
											this.state.job.status !== 'hired' && (
												<SectionTitle
													key="glassDoorCard_title"
													title="GlassDoor Summary"
												/>
											)}
										{!this.state.jobLoading &&
											this.state.job &&
											!this.state.job.privateCompanyStats &&
											!!this.state.job.glassdoorId &&
											this.state.job.status !== 'hired' && (
												<CompanyStatsCard job={this.state.job} />
											)}

										{(this.state.jobLoading ||
											this.state.offerLoading ||
											this.state.authLoading) && <SkeletonSectionTitle />}
										{(this.state.jobLoading ||
											this.state.offerLoading ||
											this.state.authLoading) && (
											<SkeletonCard header={true} actions={true} />
										)}
										{!this.state.jobLoading &&
											!this.state.offerLoading &&
											this.state.job &&
											this.state.offer &&
											this.state.job.status === 'published' &&
											!!this.state.uid && (
												<SectionTitle
													key="subscribeCard_title"
													title="Subscribe"
												/>
											)}
										{!this.state.jobLoading &&
											!this.state.offerLoading &&
											this.state.job &&
											this.state.offer &&
											this.state.job.status === 'published' &&
											!!this.state.uid && (
												<OfferSubscribeCard
													uid={this.state.uid}
													offer={this.state.offer}
													job={this.state.job}
												/>
											)}

										{!this.state.authLoading &&
											!this.state.loggedIn && (
												<SectionTitle
													key="login_section_title"
													title={`Login`}
												/>
											)}
										{!this.state.authLoading &&
											!this.state.loggedIn && <LoggedOutCard />}
									</div>
								)}
						</Hidden>
					</div>
					<Snack
						snackStatus={this.state.snackStatus}
						snackMessage={this.state.snackMessage}
						closeSnack={() => {
							this.closeSnack();
						}}
					/>
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/Offer.js